module.exports = __webpack_public_path__ + "static/media/bg_what_youll_do.81e43a46.mp4";